/**
 * Image Presets Configuration
 *
 * This file defines responsive image presets used by the Image.Model component.
 * Each preset contains configuration for generating responsive images with multiple
 * resolutions and breakpoint-specific sizing.
 *
 * How it works:
 *
 * 1. SIZES ARRAY:
 *    - Defines the display width in pixels for different breakpoints
 *    - Format: [mobile, tablet?, desktop?]
 *    - Example: [400, 600, 800] means:
 *      - Mobile: 400px wide
 *      - Tablet: 600px wide
 *      - Desktop: 800px wide
 *    - The component automatically generates CSS media queries using breakpoints:
 *      - (min-width: desktopBreakpoint) → uses desktop size
 *      - (min-width: tabletBreakpoint) and (max-width: desktopBreakpoint-1) → uses tablet size
 *      - Default → uses mobile size
 *
 * 2. SRCWIDTH ARRAY:
 *    - Defines the actual image widths to generate in the srcSet
 *    - The component automatically creates high-DPI variants (x1, x2, x3) for each width
 *    - Example: srcWidth: [400] generates images at 400px, 800px, and 1200px
 *    - This ensures sharp images on retina/high-DPI displays
 *
 * 3. GENERATED OUTPUT:
 *    - srcSet: "image-400w.jpg 400w, image-800w.jpg 800w, image-1200w.jpg 1200w"
 *    - sizes: "(min-width: 1024px) 400px, 400px" (example for single breakpoint)
 *
 * Best Practices:
 * - Keep srcWidth values aligned with your actual layout needs
 * - Consider your typical image aspect ratios when setting sizes
 * - Test on different devices to ensure optimal loading performance
 * - Use fewer preset variants to reduce bundle size and complexity
 */

export const imagePreset = {
  propertyCard: {
    sizes: [400],
    srcWidth: [400],
  },
  roomHeader: {
    sizes: [300],
    srcWidth: [300],
  },
  // thumbnail: {
  //   sizes: [150],
  //   srcWidth: [150]
  // }
} as const
